(() => {
  const root = document.querySelector('[data-scp-cookie]');
  const reopen = document.querySelector('[data-cookie-reopen]');
  if (!root || !reopen) return;
  root.dataset.scpCookieReady = 'true';

  const banner = root.querySelector('[data-cookie-banner]');
  const preferences = root.querySelector('[data-cookie-preferences]');
  const backdrop = root.querySelector('[data-cookie-backdrop]');
  const choices = [...root.querySelectorAll('[data-cookie-choice]')];
  let api = null;
  let lastFocus = null;
  let initAttempts = 0;

  const show = (element) => {
    root.hidden = false;
    element.hidden = false;
  };

  const hide = (element) => {
    element.hidden = true;
    if (banner.hidden && preferences.hidden) root.hidden = true;
  };

  const closePreferences = () => {
    hide(preferences);
    backdrop.hidden = true;
    document.documentElement.classList.remove('scp-cookie-lock');
    lastFocus?.focus();
  };

  const readConsent = () => {
    const current = api.currentVisitorConsent();
    choices.forEach((input) => {
      const value = current[input.dataset.cookieChoice];
      input.checked = value === 'yes';
    });
  };

  const openPreferences = () => {
    lastFocus = document.activeElement;
    readConsent();
    show(preferences);
    backdrop.hidden = false;
    document.documentElement.classList.add('scp-cookie-lock');
    preferences.querySelector('[data-cookie-close]')?.focus();
  };

  const saveConsent = (consent) => {
    api.setTrackingConsent(consent, () => {
      hide(banner);
      closePreferences();
      reopen.hidden = false;
      document.dispatchEvent(new CustomEvent('sofacover:consent-updated', { detail: consent }));
    });
  };

  const allowAll = () => saveConsent({
    preferences: true,
    analytics: true,
    marketing: true,
  });

  const denyAll = () => saveConsent({
    preferences: false,
    analytics: false,
    marketing: false,
    ...(api.saleOfDataRegion?.() ? { sale_of_data: false } : {}),
  });

  root.querySelectorAll('[data-cookie-allow]').forEach((button) => button.addEventListener('click', allowAll));
  root.querySelectorAll('[data-cookie-deny]').forEach((button) => button.addEventListener('click', denyAll));
  root.querySelector('[data-cookie-customize]')?.addEventListener('click', openPreferences);
  root.querySelector('[data-cookie-close]')?.addEventListener('click', closePreferences);
  backdrop.addEventListener('click', closePreferences);
  reopen.addEventListener('click', openPreferences);

  root.querySelector('[data-cookie-save]')?.addEventListener('click', () => {
    const consent = {};
    choices.forEach((input) => {
      consent[input.dataset.cookieChoice] = input.checked;
    });
    saveConsent(consent);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !preferences.hidden) closePreferences();
  });

  const init = () => {
    if (!window.Shopify?.loadFeatures) {
      initAttempts += 1;
      if (initAttempts <= 40) window.setTimeout(init, 250);
      return;
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (error || !window.Shopify.customerPrivacy) return;
        api = window.Shopify.customerPrivacy;

        if (api.shouldShowBanner()) {
          show(banner);
        } else {
          banner.hidden = true;
          reopen.hidden = false;
        }
      },
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
